
export function findClosestElementByClass(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}
export function findClosestElementByAttr(el, attr) {
    while ((el = el.parentElement) && !el.hasAttribute(attr));
    return el;
}


export default { findClosestElementByClass, findClosestElementByAttr }